
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chess-2024",
      function () {
        return require("private-next-pages/chess-2024/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chess-2024"])
      });
    }
  